import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams, ResponseContentType } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class ForSigningHttpService {

  public static ALL_CONTRACTS_URL = DevelopUtil.url('forSigning');
  public static CONTRACTS_FOR_SIGNING_COUNT_URL = DevelopUtil.url('forSigning/count');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getContracts(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(ForSigningHttpService.ALL_CONTRACTS_URL, this.requestOptions);
  }

  getSingleContract(id, urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(ForSigningHttpService.ALL_CONTRACTS_URL + '/' + id, this.requestOptions);
  }

  postDeclineContract(id, formData): Observable<Response> {
    this.requestOptions.responseType = null;
    return this.http.post(ForSigningHttpService.ALL_CONTRACTS_URL + '/' + id + '/decline', formData, this.requestOptions);
  }

  postAgreeContract(id, formData): Observable<Response> {
    this.requestOptions.responseType = null;
    return this.http.post(ForSigningHttpService.ALL_CONTRACTS_URL + '/' + id + '/agree', formData, this.requestOptions);
  }

  getContractsForSigningCount(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(ForSigningHttpService.CONTRACTS_FOR_SIGNING_COUNT_URL, this.requestOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/forsigning/forsigning.http.service.ts